import React from 'react';
import { useHistory } from 'react-router-dom';
import useReduxModal from 'Hooks/reduxHelperHooks/useReduxModal';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { RQ_ALL_REPORTS } from 'Utils';

type Args = {
    preContentMessage?: string;
    title?: string;
};

function useReportCsvErrorHandler({ preContentMessage, title }: Args = {}) {
    const { t } = useTranslation();
    const history = useHistory();
    const { addTechnicalErrorModal } = useReduxModal();
    const queryClient = useQueryClient();
    const content = (
        <>
            {t('simulationDeleted')}
            <div style={{ marginTop: '24px' }}>{t('simulationTry')}</div>
        </>
    );
    const errorHandler = React.useCallback(
        (error: any) => {
            const handleNotFound = () => {
                addTechnicalErrorModal(
                    '',
                    t('Simulation Unavailable'),
                    () => {
                        queryClient.invalidateQueries([RQ_ALL_REPORTS]);
                        history.push('/simulations');
                    },
                    {
                        status: 'warning',
                        content
                    }
                );
            };

            const handleDefault = () => {
                addTechnicalErrorModal(preContentMessage, title);
            };

            switch (error?.status) {
                case 404:
                    handleNotFound();
                    break;
                default:
                    handleDefault();
                    break;
            }
        },
        [addTechnicalErrorModal, history, preContentMessage, t, title, queryClient, content]
    );

    return errorHandler;
}

export default useReportCsvErrorHandler;
